import { NavigateOptions, To, useNavigate as useRouterNavigate } from "react-router-dom";

export function useNavigate() {
  const routerNavigate = useRouterNavigate();

  const navigate = (to: To, options?: NavigateOptions) => {
    routerNavigate(to, options);
  };

  return navigate;
}
